// extracted by mini-css-extract-plugin
export default {"suffix":"PassInput_suffix__PCXrh"};